
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { CheckMsg, InfoMsg } from "@/constants/message.constant";
type ValidateFieldCallback = (message?: string | Error) => void;
import { getUserProfile, updateUserProfile } from "@/api/account.api";
import { useUserStore } from "@/store";

export default defineComponent({
  setup() {
    const panels = reactive({
      userInfo: {
        accountId: "",
        name: "",
        email: "",
        kengen: "",
      },
      kaishaInfo: {
        kaishaName: "",
        groupName: "",
        bushoName: "",
      },
      editPassword: {
        oldPassword: "",
        password: "",
        checkPassword: "",
      },
    });
    const kaishaInfoRef = ref();
    const editPasswordRef = ref();
    const loading = ref(false);
    const router = useRouter();
    const isShineishaUser = useUserStore().isShinseisha;
    // 入力情報のチェックルール;
    const kaishaInfoRules = {
      bushoName: [
        {
          required: true,
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (isShineishaUser && value === "") {
              callback(CheckMsg.CHK_BUSHO_NM);
            } else {
              callback();
            }
          },
        },
      ],
    };
    const eidtPasswordRules = {
      oldPassword: [
        {
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (value === "" && panels.editPassword.password !== "") {
              callback(CheckMsg.CHK_PWD);
            } else {
              callback();
            }
          },
        },
      ],
      password: [
        {
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (panels.editPassword.oldPassword === "") {
              editPasswordRef.value?.validateField("oldPassword");
              callback();
            } else {
              if (value === "") {
                callback(CheckMsg.CHK_PWD);
              }
              //パスワードを設定してください。（ 12～32文字 ／英文字、数字、記号※それぞれ1種類）※ - _. * ! # $ % & + / = ? ^ ` { | } ~
              else if (
                !/^(?=.*?\d)(?=.*?[A-z])(?=.*?[-_.*!#$%&+/=?^`{|}~])[A-z\d-_.*!#$%&+/=?^`{|}~]{12,32}$/.test(
                  value
                )
              ) {
                callback(CheckMsg.CHK_CORRECT_PWD);
              } else {
                if (panels.editPassword.checkPassword !== "") {
                  editPasswordRef.value?.validateField("checkPassword");
                }
                callback();
              }
            }
          },
        },
      ],
      checkPassword: [
        {
          trigger: "blur",
          validator: (
            self: any,
            value: string,
            callback: ValidateFieldCallback
          ) => {
            if (value !== panels.editPassword.password) {
              callback(CheckMsg.CHK_SAME_PWD);
            } else {
              callback();
            }
          },
        },
      ],
    };
    //情報セット;
    const setDetailInfo = async () => {
      const {
        data: { result },
      } = await getUserProfile();
      panels.userInfo.accountId = result.account.akaunto_id;
      panels.userInfo.name = result.tanto_nm || result.kjn_nm;
      panels.userInfo.email = result.account.mail_address;
      panels.userInfo.kengen = result.account.kengen.kengen_kubun;
      panels.kaishaInfo.kaishaName = result.kaishaGroup?.kaisha?.kaisha_nm;
      panels.kaishaInfo.groupName = result.kaishaGroup?.kaisha_group_nm;
      panels.kaishaInfo.bushoName = result.busho_nm;
    };
    setDetailInfo();

    // 設定ボタン
    const handleSet = () => {
      console.log(
        kaishaInfoRef.value?.validate(),
        editPasswordRef.value?.validate()
      );

      Promise.all([
        kaishaInfoRef.value?.validate(),
        editPasswordRef.value?.validate(),
      ])
        .then(async (values) => {
          if (values[0] && values[1]) {
            loading.value = true;
            await updateUserProfile(panels.userInfo.accountId, {
              bushoName: panels.kaishaInfo.bushoName,
              oldPassword: panels.editPassword.oldPassword,
              newPassword: panels.editPassword.password,
            });

            loading.value = false;
            ElMessage({
              type: "success",
              message: InfoMsg.INFO_USER_PROFILE_UPDATED,
            });
            //画面初期化
            router.replace({ path: "/user/profile", force: true });
            panels.editPassword.oldPassword = "";
            panels.editPassword.password = "";
            panels.editPassword.checkPassword = "";
          }
        })
        .catch((error) => {
          console.log(error);
          loading.value = false;
        });
    };

    //キャンセルボタン押下
    const handleCancel = () => {
      router.back();
    };

    return {
      panels,
      kaishaInfoRef,
      editPasswordRef,
      kaishaInfoRules,
      eidtPasswordRules,
      loading,
      handleSet,
      handleCancel,
      isShineishaUser,
    };
  },
});
